import { gql, useQuery, WatchQueryFetchPolicy } from '@apollo/client';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { GetTenantByIdQueryVariables, Query } from 'generated/graphql';
import { apolloStatusToQueryStatus } from 'v2/core/repository/edge-server/statusConvertor';
import { IsLoading } from 'v2/core/repository/edge-server/types';
import { useGetUser } from 'v2/core/services/user';

export const FETCH_TENANT_SSO_SETTINGS = gql`
  query getTenantSSOSettings($tenantID: ID!) {
    getTenantByID(id: $tenantID) {
      dashboardSettings {
        ssoSettings {
          isEnabled
          isEnforced
          authSecret
        }
      }
    }
  }
`;

interface UseFetchTenantSSOSettingsOptions {
  fetchPolicy?: WatchQueryFetchPolicy;
  nextFetchPolicy?: WatchQueryFetchPolicy;
}

export const useFetchTenantSSOSettings = (
  options?: UseFetchTenantSSOSettingsOptions,
) => {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const { showErrorNotification } = useNotificationContext();

  const { data, loading, called, error } = useQuery<
    Query,
    GetTenantByIdQueryVariables
  >(FETCH_TENANT_SSO_SETTINGS, {
    variables: {
      tenantID,
    },
    fetchPolicy: options?.fetchPolicy ?? 'cache-and-network',
    nextFetchPolicy: options?.nextFetchPolicy,
    onError: () => {
      showErrorNotification({
        contentComponent: 'Failed to fetch SSO settings.',
        props: {},
      });
    },
  });

  const status = apolloStatusToQueryStatus(loading, called, false, error);

  return {
    ssoSettings: data?.getTenantByID?.dashboardSettings?.ssoSettings,
    isLoading: IsLoading(status),
    status,
  };
};
